import React, { useState, useEffect, useRef } from 'react'
import Popover from '@mui/material/Popover'
import { Button, ListItem } from '@mui/material'

function Menu({
    data,
    viewProperty,
    removeProperty,
    deleteProperty,
    handleSizeOut,
}) {
    const [menuAnchor, setMenuAnchor] = useState(null)
    const [sizeAnchor, setSizeAnchor] = useState(null)

    const handleClick = (event, type) => {
        if (type == 'size') {
            setSizeAnchor(event.currentTarget)
        } else if (type == 'menu') {
            setMenuAnchor(event.currentTarget)
        }
    }
    const handleSize = (size) => {
        handleSizeOut(data, size)
    }

    const handleClose = () => {
        setSizeAnchor(null)
        setMenuAnchor(null)
    }

    const menuOpen = Boolean(menuAnchor)
    const menuId = menuOpen ? 'simple-popover' : undefined

    const sizeOpen = Boolean(sizeAnchor)
    const sizeId = sizeOpen ? 'simple-popover' : undefined

    return (
        <>
            {console.log(data, 'checkData')}

            <div className="roAct">
                <Button
                    aria-describedby={sizeId}
                    onClick={(e) => handleClick(e, 'size')}
                >
                    <span className="material-icons">view_compact</span>
                </Button>

                <Button
                    aria-describedby={menuId}
                    onClick={(e) => handleClick(e, 'menu')}
                >
                    <span className="material-icons">more_vert</span>
                </Button>
            </div>
            <Popover
                id={sizeId}
                open={sizeOpen}
                anchorEl={sizeAnchor}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <ul className="menuItemView">
                    <ListItem className="menuTitle">Property Size</ListItem>
                    <ListItem
                        button
                        onClick={() => handleSize('col-sm-3 col-12')}
                    >
                        Small
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => handleSize('col-sm-6 col-12')}
                    >
                        Medium
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => handleSize('col-sm-12 col-12')}
                    >
                        Large
                    </ListItem>
                </ul>
            </Popover>
            <Popover
                id={menuId}
                open={menuOpen}
                anchorEl={menuAnchor}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <ul className="menuItemView">
                    <ListItem className="menuTitle">Actions</ListItem>

                    <ListItem
                        button
                        id="dynamicfield_visible"
                        onClick={() => {
                            viewProperty(), handleClose()
                        }}
                    >
                        View/Edit Property
                    </ListItem>
                    {data.is_default === 1 ? (
                        <ListItem
                            button
                            id="dynamicField_close"
                            onClick={() => {
                                removeProperty(), handleClose()
                            }}
                        >
                            Remove Property
                        </ListItem>
                    ) : (
                        <ListItem
                            button
                            id="dynamicField_delete"
                            onClick={() => {
                                deleteProperty(), handleClose()
                            }}
                        >
                            Delete Property
                        </ListItem>
                    )}
                </ul>
            </Popover>
        </>
    )
}

export default Menu
